import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { FetchOpenTradeOrders, FetchTradeOrders } from "../../api/api";

import { AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MenuModule } from "@ag-grid-enterprise/menu";

import moment from "moment";

import { formateDataCurr } from "../../utils/types";
import TradeForm from "./tradeForm";
import { IOlympicData } from "./interFace";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { useFetchOpenTradeOrders, useFetchTradeList } from "../../data/data";

const dateFilterParams = {
  comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split("-");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
  },
  browserDatePicker: true,
};

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CsvExportModule,
  ExcelExportModule,
  MenuModule,
]);

interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

function TradeTransactions({ chartTitle }: { chartTitle: string }) {
  const dataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const dataGridRefOpen = useRef<AgGridReact<IOlympicData>>(null);
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [tradeDetails, setTradeDetails] = useState<any>([]);
  const [openTradeDetails, setOpenTradeDetails] = useState<any>(null);

  const [gridApi, setGridApi] = useState<any>();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [IsStatus, setIsStatus] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [refreshRight, setRefreshRight] = useState(false);
  const token = Cookies.get("newJwt");
  const { data: orderHistory, refetch, isFetching } = useFetchTradeList(token);
  const {
    data: openOrderHistory,
    refetch: openOrdersRefetch,
    isFetching: openOrderFetching,
  } = useFetchOpenTradeOrders(token);
console.log(orderHistory, openOrderHistory)
  const orderHistoryData: any[] = [];
  const rightRowData: any[] = [];

  tradeDetails &&
    tradeDetails.map((e: any) => {
      return orderHistoryData.push({
        Date: moment(e.enteredTime.slice(0, 10)).format("DD-MM-YYYY"),
        Status: e.status,
        Order: e.orderType,
        Qty: e.quantity,
        Price: e.price,
        Symbol: e.orderLegCollection[0].instrument.symbol,
      });
    });

  openTradeDetails &&
    openTradeDetails.map((e: any) => {
      return rightRowData.push({
        Date: moment(e.enteredTime.slice(0, 10)).format("DD-MM-YYYY"),
        Order: e.orderType,
        Qty: e.quantity,
        Price: e.price,
        Status: e.status,
        Symbol: e.orderLegCollection[0].instrument.symbol,
      });
    });

  const [columns, setColumns] = useState([
    {
      headerName: "Symbol",
      field: "Symbol",
      width: 90,
      filter: "agTextColumnFilter",
      floatingFilter: true,
    },
    {
      headerName: "Date",
      field: "Date",
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      sortable: true,
      floatingFilter: true,
      width: 140,
    },
    {
      headerName: "Status",
      field: "Status",
      filter: "agSetColumnFilter",
      floatingFilter: true,
      width: 80,
    },
    {
      headerName: "Order",
      field: "Order",
      width: 70,
      filter: "agSetColumnFilter",
      floatingFilter: true,
    },
    { headerName: "Qty", field: "Qty", width: 50 },
    {
      headerName: "Price",
      field: "Price",
      cellRenderer: formateDataCurr,
      width: 80,
    },
  ]);
  const [columnsRight, setColumnsRight] = useState([
    { headerName: "Symbol", field: "Symbol", sortable: true, width: 100 },
    {
      headerName: "Date",
      field: "Date",
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      sortable: true,
      floatingFilter: true,
      width: 140,
    },
    //{ headerName: "Status", field: "Status", filter: 'agButtonColumnFilter'},
    { headerName: "Order", field: "Order", width: 100 },
    { headerName: "Qty", field: "Qty", width: 80 },
    {
      headerName: "Price",
      field: "Price",
      cellRenderer: formateDataCurr,
      width: 80,
    },
  ]);

  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      refreshCells: true,
      //flex:1
    }),
    []
  );

  const getFilterType = () => {
    if (startDate !== "" && endDate !== "" && IsStatus !== "") return "inRange";
    else if (startDate !== "") return "greaterThan";
    else if (endDate !== "") return "lessThan";
    else if (IsStatus !== "") return "Status";
  };

  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      setTradeDetails(orderHistory);
      // FetchTradeOrders("2022-06-01", "2022-12-31", Cookies.get("newJwt"))
      //   .then((response) => response.json())
      //   .then((response) => {
      //     setTradeDetails(response);
      //   });
    },
    [orderHistory]
  );

  const onGridReadyRight = useCallback(
    (params: GridReadyEvent) => {
      setOpenTradeDetails(openOrderHistory);
      // FetchOpenTradeOrders("2022-06-01", "2022-12-31", Cookies.get("newJwt"))
      //   .then((response) => response.json())
      //   .then((response) => {
      //     setOpenTradeDetails(response);
      //   });
    },
    [openOrderHistory]
  );

  useEffect(() => {
    if (gridApi) {
      if (startDate !== "" && endDate !== "" && startDate > endDate) {
        alert("Start Date should be before End Date");
        setEndDate("");
      } else {
        var dateFilterComponent = gridApi.api.getFilterInstance(
          "Date",
          "Status"
        );
        dateFilterComponent.setModel({
          type: getFilterType(),
          status: IsStatus,
          dateFrom: startDate ? startDate : endDate,
          dateTo: endDate,
        });

        gridApi.api.onFilterChanged();
      }
    }
  }, [startDate, endDate, gridApi]);

  const onBtExport = useCallback(() => {
    dataGridRef.current!.api.exportDataAsExcel();
  }, []);

  const onBtExportMain = useCallback(() => {
    dataGridRefOpen.current!.api.exportDataAsExcel();
  }, []);

  const orderHistoryrefresh = useCallback(() => {
    refetch();
  }, [refetch]);

  const openTraderefresh = useCallback(() => {
    openOrdersRefetch();
  }, [openOrdersRefetch]);

  const exportOrderHistoryData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Order History";
    const headers = [["Symbol", "Date", "Status", "Order", "Qty", "Price"]];

    const data = orderHistoryData.map((e: any) => [
      e.Symbol,
      e.Date,
      e.Status,
      e.Order,
      e.Qty,
      e.Price,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("orderHistoryReport.pdf");
  };

  const exportOpenTradesData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Order History";
    const headers = [["Symbol", "Date", "Status", "Order", "Qty", "Price"]];

    const data = rightRowData.map((e: any) => [
      e.Symbol,
      e.Date,
      e.Status,
      e.Order,
      e.Qty,
      e.Price,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("orderHistoryReport.pdf");
  };

  return (
    <div className="row w-100">
      <TradeForm />
      <div className="card mr-2" style={{ width: "49%", marginRight: "15px" }}>
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters px-2">
          <h5 className="card-title float-start">Order History</h5>

          <i
            className="float-end me-2 fas fa-fw fa-sync cursor-pointer"
            onClick={orderHistoryrefresh}
            style={{ fontSize: "16px" }}
          ></i>
          <i
            className="float-end me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={onBtExport}
          ></i>
          <i
            className="float-end me-2 far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => exportOrderHistoryData()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "500px",
                    width: "100%",
                  }}
                >
                  {isFetching ? (
                    <div className="w-100 grid_loader">
                      <div
                        className="spinner-border text-dark me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <AgGridReact<IOlympicData>
                      ref={dataGridRef}
                      rowData={orderHistoryData}
                      columnDefs={columns}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReady}
                      animateRows={true}
                      popupParent={document.body}
                      pagination={true}
                      paginationPageSize={20}
                      //paginationAutoPageSize={true}
                    ></AgGridReact>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mr-2" style={{ width: "49%" }}>
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters px-2">
          <h5 className="card-title float-start">Open Trades</h5>
          <div>
            <i
              className="float-end me-2 fas fa-fw fa-sync cursor-pointer"
              onClick={openTraderefresh}
              style={{ fontSize: "16px" }}
            ></i>
            <i
              className="float-end me-2 far fa-fw fa-file-excel cursor-pointer"
              style={{ fontSize: "16px" }}
              onClick={onBtExportMain}
            ></i>
            <i
              className="float-end me-2 far fa-fw fa-file-pdf cursor-pointer"
              onClick={() => exportOpenTradesData()}
              style={{ fontSize: "16px" }}
            ></i>
          </div>
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "500px",
                    width: "100%",
                  }}
                >
                  {openOrderFetching ? (
                    <div className="w-100 grid_loader">
                      <div
                        className="spinner-border text-dark me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <AgGridReact<IOlympicData>
                      ref={dataGridRefOpen}
                      rowData={rightRowData}
                      columnDefs={columns}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReadyRight}
                      animateRows={true}
                      popupParent={document.body}
                      pagination={true}
                      paginationPageSize={20}
                      //paginationAutoPageSize={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { TradeTransactions };
